import { render } from "./ServicePaymentContent.vue?vue&type=template&id=6166711a"
import script from "./ServicePaymentContent.vue?vue&type=script&lang=js"
export * from "./ServicePaymentContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__